import { useEffect, useState } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { environment } from "environment/environment";

const getRowsFromMessage = (messageBody) => {
  const payload = JSON.parse(messageBody);

  if (Array.isArray(payload)) {
    return payload;
  }

  return Array.isArray(payload?.data) ? payload.data : [];
};

const getConnectionError = (error) =>
  error?.message || "Upstox OTM option premium stream is unavailable.";

export default function useUpstoxOtmOptionPremiumWebsocket(
  accountName,
  enabled = true,
  socketUrl = environment.stockApiDayRangeDataWSUrl
) {
  const [rows, setRows] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (typeof window === "undefined" || !enabled || !accountName) {
      setIsConnected(false);
      return undefined;
    }

    const destination = `${environment.stoackApiTopic}${environment.upstoxOtmOptionPremiumTopic}/${encodeURIComponent(accountName)}`;
    const stompClient = new Client({
      webSocketFactory: () => new SockJS(socketUrl),
      reconnectDelay: 5000,
      connectionTimeout: 10000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      discardWebsocketOnCommFailure: true,
      debug: () => {},
    });

    stompClient.onConnect = () => {
      setIsConnected(true);
      setError("");

      stompClient.subscribe(destination, (message) => {
        try {
          setRows(getRowsFromMessage(message.body));
        } catch (parseError) {
          setError(getConnectionError(parseError));
        }
      });
    };

    stompClient.onStompError = (frame) => {
      setIsConnected(false);
      setError(frame.headers?.message || "Upstox OTM option premium stream failed.");
    };

    stompClient.onWebSocketError = (webSocketError) => {
      setIsConnected(false);
      setError(getConnectionError(webSocketError));
    };

    stompClient.onWebSocketClose = () => setIsConnected(false);
    stompClient.onDisconnect = () => setIsConnected(false);
    stompClient.activate();

    return () => {
      setIsConnected(false);
      if (stompClient.active) {
        void stompClient.deactivate().catch((deactivateError) => {
          console.error("Failed to close Upstox OTM premium stream:", deactivateError);
        });
      }
    };
  }, [accountName, enabled, socketUrl]);

  return { rows, isConnected, error };
}
